import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./components/Header";
import Button from "./components/Button";
import Card from "./components/Card";
import "./Login.css";

const API = '/api';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [msg, setMsg]           = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [token, setToken]       = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (!t) {
      setError('Invalid reset link!');
    } else {
      setToken(t);
    }
  }, []);

  const handleReset = async () => {
    if (!password)          { setError('Password daalo!'); return; }
    if (password.length < 6){ setError('Kam az kam 6 characters!'); return; }
    setLoading(true);
    setError('');
    try {
      const res  = await fetch(`${API}/reset_password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (data.success) {
        setMsg('✓ Password reset ho gaya! Login page pe ja rahe hain...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError(data.message || 'Link expire ho gaya! Dobara forget password karo.');
      }
    } catch {
      setError('Connection error!');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <Header onLogoClick={() => navigate('/')} />

      <div className="reset-wrap">
        <Card className="reset-card">
          <h2 className="reset-heading">🔑 Naya Password Set Karo</h2>
          <p className="reset-sub">Apna naya password daalo.</p>

          {error && <p className="forgot-error">{error}</p>}
          {msg   && <p className="forgot-success">{msg}</p>}

          {!msg && (
            <>
              <input
                type="password"
                className="forgot-input"
                placeholder="Naya password (min 6 chars)"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') handleReset(); }}
              />
              <Button variant="primary" style={{ width: '100%' }} onClick={handleReset} disabled={loading}>
                {loading ? 'Reset ho raha hai...' : 'Password Reset Karo →'}
              </Button>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
